module.exports = __webpack_public_path__ + "static/media/operativeCheck.5cbebb2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/operativeCheck.png
// module id = 613
// module chunks = 0